import { api } from '@/lib/api'

export function getPaymentCyclesCount() {
  return api.get<{ pendingCyclesCount: number }>(`/v1/me/payment-cycles/count`)
}
